import { cx } from "shared/utils";
import { CSSProperties, MouseEventHandler, ReactNode } from "react";
import { Link } from "react-router-dom";

interface CardProps {
  className?: string;
  children: ReactNode;
  onClick?: MouseEventHandler<HTMLDivElement>;
  linkTo?: string;
  style?: CSSProperties;
}

export const Card = ({
  children,
  className,
  onClick,
  linkTo,
  style
}: CardProps) => {
  const classNames = cx(
    "rounded-lg border border-alpha-100 bg-content-1000-inverted shadow-xs",
    onClick || linkTo
      ? "hover:border-alpha-200 hover:shadow-lg cursor-pointer"
      : "",
    className
  );

  if (linkTo)
    return (
      <Link to={linkTo} className={classNames} style={style}>
        <div>{children}</div>
      </Link>
    );

  return (
    <div className={classNames} onClick={onClick} style={style}>
      {children}
    </div>
  );
};
